import {
  AI_V2_UPDATE_STATE,
  AI_V2_SET_MESSAGES,
  AI_V2_SET_CONVERSATION_ID,
  AI_V2_CLEAR_CONVERSATION,
  AI_V2_RECEIVE_HANDOFF,
  AI_V2_CLEAR_HANDOFF,
} from '.';

export const setAIV2ChatState = (isChatOpen: boolean) => ({
  type: AI_V2_UPDATE_STATE,
  payload: {
    isChatOpen,
  },
});

// No shared V2 message type yet — the message shape lives with the web
// panda-chat-v2 components. Kept permissive until it's promoted to shared.
export const setAIV2Messages = (messages: unknown[]) => ({
  type: AI_V2_SET_MESSAGES,
  payload: { messages },
});

export const setAIV2ConversationId = (conversationId: string) => ({
  type: AI_V2_SET_CONVERSATION_ID,
  payload: { conversationId },
});

export const clearAIV2Conversation = () => ({
  type: AI_V2_CLEAR_CONVERSATION,
});

/**
 * Open the chat on an exchange from another surface (today: the search card).
 * Only the signal goes through Redux — `conversationId` doubles as the handoff
 * id, freshly minted per handoff; the exchange itself travels on the handoff bus.
 */
export const receiveAIV2Handoff = ({ conversationId }: { conversationId: string }) => ({
  type: AI_V2_RECEIVE_HANDOFF,
  payload: {
    conversationId,
    // A handoff starts a new exchange — drop any persisted previous one.
    messages: [],
    handoffId: conversationId,
    isChatOpen: true,
  },
});

/** The chat has taken the handoff; it must not be adopted twice. */
export const clearAIV2Handoff = () => ({
  type: AI_V2_CLEAR_HANDOFF,
});
